export const DB_ENUMS = {
    CURRENT_CREDIT_SCORE: ["N/A", "< 620", "621-640", "641-660", "661-680", "681-700", "701-720", "721-740", "> 740"],
    CURRENT_MONTHLY_INCOME: ["No Income", "$1k-$5k", "$5k-$10k", "$10k-$50k", ">50k"],
    CREDIT_CARDS: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    MESSAGE_TYPE: ["sms", "email"],
    MESSAGE_TYPE_BOTH: ["sms", "email", "both"],
    CONTACT_TYPE: ["user", "credit_lead", "credit_client", "restate_lead", "restate_client"],
    CRUD_TYPE: ["create", "read", "update", "delete"],
    ACTIVITY_ACTION: ["create", "edit", "delete"],
    ACTIVITY_TYPE: ["message", "group", "task", "appointment", "campaign", "lead", "client", "bulk-message"],
    ACTIVITY_TABS: [
        "BANKRUPTCY",
        "OVERALL",
        "DOCUMENTS",
        "NOTES",
        "PAYMENT",
        "FINANCIAL DISCLOSURE",
        "REAL ESTATE",
        "PROCESSING",
        "SETTLEMENT",
        "ACCOUNTS",
        "APPOINTMENTS",
        "TASKS",
        "PROGRAMS",
        "FUNDING",
        "VIOLATIONS",
        "TRADELINES",
        "AGREEMENTS",
        "CALLS",
        "CONVERSATION",
        "OPPORTUNITIES",
        "COMMISSIONS"
    ],
    ACTIVITY_FILTER_GROUPS: [
        { label: "All", value: "ALL" },
        { label: "Notes", value: "NOTES" },
        { label: "Programs", value: "PROGRAMS" },
        { label: "Payments", value: "PAYMENTS" },
        { label: "Commissions", value: "COMMISSIONS" },
        { label: "Communications", value: "COMMUNICATIONS" },
        { label: "Documents", value: "DOCUMENTS" },
        { label: "Calendar", value: "CALENDAR" },
        { label: "Opportunities", value: "OPPORTUNITIES" },
        { label: "Other", value: "OTHER" },
    ] as { label: string; value: string }[],
    STATUS_PENDING: ["Contact", "Agent"],
    SOURCE_TYPE: [
        "facebook",
        "twitter",
        "realestatelane_website",
        "creditclubrepair_website",
        "MANUAL",
        "phone",
        "email",
        "instagram",
        "tiktok",
    ],
    STATUS_TYPE: [
        "Business Associate",
        "Cold Lead",
        "Competitor",
        "Consultant",
        "Contractor",
        "Co-Worker",
        "Customer",
        "Decision Maker",
        "Distributor",
        "Employee",
        "Family",
        "Friend",
        "Gate Keeper",
        "Hot Lead",
        "Influencer",
        "Investor",
        "Key Customer",
        "Lead",
        "Manufacturer",
        "Personal",
        "Prospect",
        "Qualified Lead",
        "Reseller",
        "Retailer",
        "Shareholder",
        "Supplier",
        "Vendor",
        "Warm Lead",
        "Wholesaler",
    ],
    GOAL_TYPE: [""],
    PROGRAM_TYPE: [""],
    LEGAL_STATUS: ["married", "single", "widowed"],
    CITIZENSHIP_STATUS: ["us citizen", "itin", "employment authorization", "green card", "other"],
    DOCUMENT_TYPE: ["SSN", "ITIN", "Neither"],
    CORPORATION_TYPE: ["Corporation", "LLC", "Sole-Proprietor", "Other", "Neither"],
    BUSINESS_STATUS: ["Active", "Closed", "Inactive"],
    CLASS_CERT: ["1st", "2nd"],
    OWN_RENT: ["own", "rent", "neither"],
    PAYMENT_TYPE: ["mortgage", "rent"],
    INSURANCE_TYPE: ["home", "rent"],
    CARRIER_TYPE: ["own", "rent"],
    EMPLOYEE_TYPE: ["w2", "1099", "cash", "unemployed"],
    ACCOUNT_STATUS: [""],
    SETTLEMENT_STATUS: [""],
    PRIORITY_TYPE: ["Highest", "High", "Medium", "Low"],
    APPOINTMENT_TYPE: ["lead_appointment", "client_appointment"],
    GROUP_STATUS: ["active", "no_active"],
    ROLE_PRETIFIER: [
        { value: "super_admin", name: "Super Admin" },
        { value: "agent_all", name: "Agent" },
        { value: "agent_credit", name: "Credit Agent" },
        { value: "agent_restate", name: "Real Estate Agent" },
        { value: "admin_all", name: "Admin" },
        { value: "admin_credit", name: "Credit Admin" },
        { value: "admin_restate", name: "Real Estate Admin" },
    ],
    ROLE_USER: [
        // { value: "super_admin", label: "Super Admin" },
        { value: "Agent", label: "Agent" },
        { value: "Credit Agent", label: "Credit Agent" },
        { value: "Real Estate Agent", label: "Real Estate Agent" },
        { value: "Admin", label: "Admin" },
        { value: "Credit Admin", label: "Credit Admin" },
        { value: "Real Estate Admin", label: "Real Estate Admin" },
        { value: "Subadmin", label: "Subadmin" },
        { value: "Owner", label: "Owner" },
    ],
    MESSAGE_TYPE_DROPDOWN: [
        { value: "sms", label: "sms" },
        { value: "email", label: "email" },
    ],
    CONTACT_TYPE_DROPDOWN: [
        { value: "lead", label: "Lead" },
        { value: "client", label: "Client" },
        { value: "both", label: "Both" },
    ],
    CONTACT_TYPE_CAMPAIGN: [
        "lead",
        "client",
        "both"
    ],
    MESSAGE_TYPE_BOTH_DROPDOWN: [
        { value: "sms", label: "Text Message" },
        { value: "email", label: "Email" },
        { value: "both", label: "Both" },
    ],
    RED_FLAG: ["true", "false"],
    CONTACTED: ["true", "false"],
    CALENDAR_FILTER: ["All", "Tasks", "Appointments"],
    PAYMENT_OPTIONS: [
        { value: 0, label: 'Paid in full' },
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 4, label: 4 },
        { value: 5, label: 5 },
        { value: 6, label: 6 },
        { value: 7, label: 7 },
        { value: 8, label: 8 },
        { value: 9, label: 9 },
        { value: 10, label: 10 },
        { value: 11, label: 11 },
        { value: 12, label: 12 },
        { value: 18, label: 18 },
        { value: 24, label: 24 },
    ],
    PAYMENT_INTERVALS: [
        { value: 30, label: '30 Days' },
        { value: 14, label: '14 Days' },
        { value: 7, label: '7 Days' },
    ],
    YES_NO: [
        { value: "true", label: 'Yes' },
        { value: "false", label: 'No' },
    ],
    BUYING_TIMELINE: [
        "Immediatley", // Today - +30 dias
        "1-3 months", // Day X - Day Y
        "4-6 Months", // Day X - Day Y
        "7-9 Months", // Day X - Day Y
        "9-12 Months", // Day X - Day Y
        "+12 Months", // +1 Year - +1 Year + 4 Months
    ],
    BUYER_OPPORTUNITY_STAGES: [
        "New Lead",
        "Doc Collection",
        "Needs Credit",
        "Pre-Approved",
        "In Escrow",
        "Closed Escrow",
        "Not Interested",
        "Doesn't Qualify",
    ],
    BUYER_OPPORTUNITY_STATUS_SHOW: {
        "New Lead": "New Lead",
        "Doc Collection": "Doc Collection",
        "Needs Credit": "Needs Credit",
        "Pre-Approved": "Pre-Approved",
        "In Escrow": "In Escrow",
        "Closed Escrow": "Closed Escrow",
        "Not Interested": "Not Interested",
        "Doesn't Qualify": "Doesn't Qualify",
    },
    BUYER_OPPORTUNITY_TEMPERATURES: [
        "Hot",
        "Warm",
        "Cold",
    ],
    SELLER_OPPORTUNITY_TEMPERATURES: [
        "Hot",
        "Warm",
        "Cold",
    ],
    HELOC_OPPORTUNITY_TEMPERATURES: [
        "Hot",
        "Warm",
        "Cold",
    ],
    CR_OPPORTUNITY_STAGES: [
        "Data Collection",
        "Docs & Signs",
        "Follow Up",
        "Appointment",
        "Quoted",
        "Rescheduel Appointment",
        "Sell",
        "Not Interested",
    ],
    CR_OPPORTUNITY_STATUS_SHOW: {
        "Data Collection": "Data Collection",
        "Docs & Signs": "Docs & Signs",
        "Follow Up": "Follow Up",
        "Appointment": "Appointment",
        "Quoted": "Quoted",
        "Rescheduel Appointment": "Reschedule",
        "Sell": "Sell",
        "Not Interested": "Not Interested",
    },
    MORTGAGE_SERVICE_TYPES: [
        "Mortgage",
        "Refinancing",
    ],
    MORTGAGE_OPPORTUNITY_STAGES: [
        "New Lead",
        "Screened",
        "Pending Credit",
        "Initial Docs + 1003",
        "Pending Proposal",
        "Proposal Accepted",
        "Prequalified",
        "Application Started",
        "Submitted to Lender",
        "Loan Approval Received / Conditions",
        "CTC",
        "Docs Out",
        "Funded",
        "Lost",
        "Commission Paid",
    ],
    REFINANCING_OPPORTUNITY_STAGES: [
        "New Lead",
        "Screened",
        "Pending Credit",
        "Initial Docs + 1003",
        "Pending Proposal",
        "Proposal Accepted",
        "Hard Money",
        "Application Started",
        "Submitted to Lender",
        "Loan Approval Received / Conditions",
        "CTC",
        "Docs Out",
        "Funded",
        "Lost",
        "Commission Paid",
    ],
    MORTGAGE_OPPORTUNITY_STATUS_SHOW: {
        "New Lead": "New Lead",
        "Screened": "Screened",
        "Pending Credit": "Pending Credit",
        "Initial Docs + 1003": "Initial Docs + 1003",
        "Pending Proposal": "Pending Proposal",
        "Proposal Accepted": "Proposal Accepted",
        "Prequalified": "Prequalified",
        "Application Started": "Application Started",
        "Submitted to Lender": "Submitted to Lender",
        "Loan Approval Received / Conditions": "Loan Approval Received / Conditions",
        "CTC": "CTC",
        "Docs Out": "Docs Out",
        "Funded": "Funded",
        "Commission Paid": "Commission Paid",
        "Lost": "Lost",
    },
    SELLER_OPPORTUNITY_STAGES: [
        "New Lead",
        "Listing Presentation",
        "Follow Up",
        "Listing Agreement Signed",
        "Market ready",
        "Active Listing",
        "Offer Received",
        "Open Escrow",
        "Closed Escrow",
        "Cancelled Lost (Not Interested/ Not Selling)",
    ],
    SELLER_OPPORTUNITY_STATUS_SHOW: {
        "New Lead": "New Lead",
        "Listing Presentation": "Listing Presentation",
        "Follow Up": "Follow Up",
        "Listing Agreement Signed": "Listing Agreement Signed",
        "Market ready": "Market ready",
        "Active Listing": "Active Listing",
        "Offer Received": "Offer Received",
        "Open Escrow": "Open Escrow",
        "Closed Escrow": "Closed Escrow",
        "Cancelled Lost (Not Interested/ Not Selling)": "Cancelled Lost (Not Interested/ Not Selling)",
    },
    HELOC_OPPORTUNITY_STAGES: [
        "New Lead",
        "Data Collection",
        "Screened",
        "Pending Proposal",
        "Proposal Accepted",
        "Income & Bank Account Verification",
        "Loan Approval Received",
        "Conditions",
        "Rescission Period / CTC — Clear to Close",
        "Funded",
        "Payment Received",
        "Lost",
    ],
    HELOC_OPPORTUNITY_STATUS_SHOW: {
        "New Lead": "New Lead",
        "Data Collection": "Data Collection",
        "Screened": "Screened",
        "Pending Proposal": "Pending Proposal",
        "Proposal Accepted": "Proposal Accepted",
        "Income & Bank Account Verification": "Income & Bank Account Verification",
        "Loan Approval Received": "Loan Approval Received",
        "Conditions": "Conditions",
        "Rescission Period / CTC — Clear to Close": "Rescission Period / CTC — Clear to Close",
        "Funded": "Funded",
        "Payment Received": "Payment Received",
        "Lost": "Lost",
    },
    LOST_REASON_HELOC: [
        "Credit score too low",
        "Not enough equity",
        "Not enough savings / down payment",
        "DTI too high / too much debt",
        "Income too low",
        "Unrealistic expectations",
        "Property issue",
        "Legal / personal situation",
        "Going with another lender",
        "Not interested",
    ],
    DOCUMENT_TAG_PROGRAM: [
        "Contract",
    ],
    DOCUMENT_TAG_BUSINESS: [
        "Articles of Inc.",
        "EIN Letter",
        "Business Taxes",
        "Business Bank Statements",
        "P&L Letter",
        "Personal Taxes",
    ],
    LOAN_TERMS: [
        "15 Years",
        "20 Years",
        "25 Years",
        "30 Years",
        "40 Years",
        "5/1 ARM",
        "7/1 ARM",
        "10/1 ARM",
        "3/1 ARM",
        "10-Year Balloon Mortgage",
        "15-Year Balloon Mortgage",
    ],
    REFINANCING_GOALS: [
        "Lower Monthly Payments",
        "Reduce Interest Rate",
        "Shorter Loan Term",
        "Consolidating Debt",
        "Accessing Home Equity (Cash-Out)",
        "Switch from Adjustable to Fixed Rate",
        "Lower Mortgage Insurance",
        "Remove a Co-Borrower",
    ],
    REFINANCE_TYPES: [
        "W2 or Full doc",
        "Bank Statements Only",
        "P&L Only",
        "DSCR",
        "1099",
    ],
    MORTGAGE_LOAN_TYPE: [
        "Fixed-rate Mortgage",
        "Adjustable-rate Mortgage (ARM)",
        "Interest-only Mortgage",
        "FHA Loan",
        "VA Loan",
        "USDA Loan",
        "Conventional Loan",
        "Jumbo Loan",
        "Balloon Mortgage",
        "Reverse Mortgage",
        "Commercial",
        "ITIN 3.5%",
    ],
    INTEREST_RATE_TYPE: [
        "Fixed Rate",
        "Variable Rate",
        "Adjustable Rate",
        "Hybrid Rate",
        "Teaser Rate",
        "Discounted Rate",
        "Prime Rate",
        "Subprime Rate",
        "Cap Rate",
        "Floor Rate",
    ],
    EMPLOYMENT_STATUS: [
        "W2",
        "1099",
        "Selfemployed",
        "Unemployed"
    ],
    PROPERTY_TYPE: [
        "Residential",
        "Rental",
        "Mobilehome",
        "Condominium",
        "Multifamily",
        "Commercial",
        "Land",
        "Farm"
    ],
    PROPERTY_SPECIAL_REQUIREMENTS: [
        "Pool",
        "Garage",
    ],
    USA_STATES: [
        "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
        "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
        "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
        "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
        "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
    ],
    TIME_AT_ADDRESS: [
        "0-6 Months",
        "6-12 Months",
        "1-3 Years",
        "4-5 Years",
        "6-8 Years",
        "9-12 Years",
        "12+ Years",
    ],
    INVESTMENT_TYPE_FD: [
        "Primary Residence",
        "Secondary Residence",
        "Second Home",
        "Commercial Property",
        "Other"
    ],
    PAST_FINANCIAL_ISSUES: [
        "Bankruptcy",
        "Foreclosure",
        "Lates (Past 12 Months)",
        "Collections",
        "Charge-Offs",
        "Disputes",
        "None",
    ],
    APPOINTMENT_CALL_TYPE: [
        "Video Call",
        "Phone Call",
        "In-Person",
    ],
    LOST_REASON_MORTGAGE_REFINANCING: [
        "Credit score too low",
        "Not enough equity",
        "Not enough savings / down payment",
        "DTI too high / too much debt",
        "Income too low",
        "Unrealistic expectations",
        "Property issue",
        "Legal / personal situation",
        "Going with another lender",
        "Not interested",
    ]
};
